import InputChipsField, { InputChipsFieldProps } from './InputChipsField';

export type { InputChipsFieldProps };
export default InputChipsField;
